import { Modal } from 'components/Modal/Modal';
import { LabelValueColumn } from 'components/TableColumn/LabelValueColumn';
import i18n from 'i18n';
import styles from './siteAnnouncementDetailModal.module.scss';
import { SiteAnnouncement } from 'core/siteAnnouncement/SiteAnnouncement';
import { useMemo } from 'react';
import { SiteAnnouncementContent } from 'components/SiteAnnouncement/SiteAnnouncementContent';
import { InfoModal } from 'components/InfoModal/InfoModal';

export const SiteAnnouncementDetailModal: React.FC<{
  announcement: SiteAnnouncement;
  onClose: () => void;
}> = ({
  announcement,
  onClose
}) => {

  const contents = useMemo(
    () => [
      {
        label: i18n.t<string>('siteAnnouncementList.headers.name'),
        value: announcement.name
      },
      {
        label: i18n.t<string>('siteAnnouncementList.headers.content'),
        value: (
          <SiteAnnouncementContent
            content={announcement.content}
            macroToHyperlink
          />
        )
      },
      {
        label: i18n.t<string>('siteAnnouncementList.headers.publishTime'),
        value: announcement.publishTime
      }
    ],
    [announcement]
  );

  return (
    <Modal
      title=''
      className={styles.infoModalContainer}
      dismiss={onClose}
    >
      <InfoModal className={styles.infoModal} onClose={onClose}>
        <LabelValueColumn
          className={styles.labelValueColumn}
          options={contents}
        />
      </InfoModal>
    </Modal>
  );
};
